import { React, useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { useDisclosure } from '@mantine/hooks';

import { TextInput, Button, Modal, ThemeIcon, Blockquote  } from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconExchange, IconWorldStar, IconFlagPin } from '@tabler/icons-react';
import 'dayjs/locale/fr';


import Navbar from '../Navbar/NavbarPublic';
import Footer from '../Footer/Footer';
import CookieConsent from "react-cookie-consent";
import Maintenance from './Maintenance';

import MeetingPic from '../../composents/Pictures/meeting/meeting.js'
import RSEPic from '../../composents/Pictures/rseHomePage/rsePic.js';

const Home = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [opened, { open, close }] = useDisclosure(false);
    
    
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0,0);
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
          };
          window.addEventListener('resize', handleResize);
          return () => {
            window.removeEventListener('resize', handleResize);
          };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const maintenance = false ;

    const form1 = useForm({
          initialValues: {
            email: ''
          },
      
          validate: {
            email : (value) => (
                value.length < 1
                ? 'Renseignez votre E-mail'
                : /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value) 
                ? null 
                : 'E-mail non valide'
            ),
         },
    });

    const form2 = useForm({
          initialValues: {
            email: ''
          },
      
          validate: {
            email : (value) => (
                value.length < 1
                ? 'Renseignez votre E-mail'
                : /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value) 
                ? null 
                : 'E-mail non valide'
            ),
         },
    });
    
    
        
    const handleFormSubmit = async (values, _event) => {
        _event.preventDefault();
        try {
            open();
             setTimeout(() => {
                navigate('/');
            }, 500)
        } catch (error) {
        }
    }

    return(
        <>
            {maintenance ? (
                <Maintenance />
            ) : (
                <>
                    <Navbar/>
                        <div>
                            {isMobile ? (
                                <>
                                    <CookieConsent 
                                        debug={true}
                                        location="bottom"
                                        buttonText="Accepter"
                                        cookieName="complianceRGPD_ga"
                                        style={{ 
                                            background: "#303030",
                                            color: "#FFFFFF",
                                            fontFamily: "'Segoe UI', sans-serif",
                                            paddingLeft: "10px",
                                            maxWidth: "100vw",
                                            boxSizing: "border-box",
                                        }}
                                        buttonStyle={{ fontWeight: "bold", color: "#000000", background: "#FFFFFF", fontSize: "16px", borderRadius: "2px", marginRight: "40px" }}
                                        enableDeclineButton
                                        declineButtonText="Refuser"
                                        declineButtonStyle={{ color: "#FFFFFF", background: "#303030", fontSize: "16px", borderRadius: "2px", borderWidth:"10px", borderColor:"#FFFFFF", marginRight: "5px" }}
                                        expires={150}    
                                        >                                    
                                        <p className='txt16'>
                                            Nous utilisons des cookies pour optimiser votre expérience utilisateur et pour améliorer nos contenus.
                                        </p>
                                    </CookieConsent>
                                    <div className='horizontal spaceBtw bLiteGrey w100'>
                                        <div className='width90pCenter mrgB10 w60'>
                                            <div>
                                                <p className='mrgT100 txt30 medium lineH33 mrgB20'>
                                                    boldee, un espace d’offres interentreprises pour donner une seconde vie à vos ressources
                                                </p>
                                            </div>
                                            <div>
                                                <p className='mrgB20 txt18 mrgT10 vertical'>
                                                    <p className='noMrgT mrgB10 thin'>Entreprises et Collectivités : créer de la valeur avec l’existant, réduire les coûts, agir durablement.</p>
                                                </p>
                                            </div>
                                        </div>                      
                                    </div>
                                    <div className='bLiteGrey'>
                                        <form onSubmit={form1.onSubmit(handleFormSubmit)}>
                                            <div className="vertical txtLeft width90pCenter">
                                                <div className='mrgB10'>
                                                <TextInput
                                                    size="sm"
                                                    placeholder="votre@email.com"
                                                    {...form1.getInputProps('email')}
                                                /> 
                                                </div>
                    
                                                <div className='mrgB50'>
                                                    <Button 
                                                        type="submit"
                                                        color="green"
                                                        size="sm"
                                                        >
                                                        <span className='txt14 bT'>Recevez notre plaquette</span>
                                                    </Button>
                                                    {open  
                                                        ?   <Modal 
                                                                centered
                                                                size="auto"
                                                                opened={opened}
                                                                onClose={close}
                                                                withCloseButton={false}>
                                                                <p className=" txt15 txtCenter noMrgTB">
                                                                    Notre plaquette vous a été envoyé
                                                                </p>
                                                            </Modal> 
                                                        :   ""
                                                    }
                                                </div>
                                            </div>
                                        </form>                          
                                    </div>
                                    
                                    
                                    <div className="width90pCenter vertical iStart mrgT50 mrgB50 spaceBtw">
                                        
                                        <div className='mrgB50'>
                                            <ThemeIcon size="xl" className='noMrgTB' color="#40c057">
                                                <IconExchange style={{ width: '70%', height: '70%' }} />
                                            </ThemeIcon>
                                            <p className='medium txt16 mrgB5 mrgT10 lineH23'>Ne laissez plus vos ressources matérielles et immatérielles dormir</p>
                                            <p className='noMrgT mrgB10 txt16 thin'>
                                                Vendez ou louez vos locaux, équipements, outils ou savoir-faire pour générer des revenus, et économisez grâce aux offres disponibles sur la plateforme boldee.
                                            </p>
                                            <Link to="/" className="aReset bT mrgT20">
                                                <Button variant="outline" size="xs" color="gray" radius="xl">
                                                    <p className='txt14'>Découvrir</p>
                                                </Button>
                                            </Link>
                                        </div>
                                        <div className='mrgB50'>
                                            <ThemeIcon size="xl" className='noMrgTB' color="#40c057">
                                                <IconFlagPin style={{ width: '70%', height: '70%' }} />
                                            </ThemeIcon>
                                            <p className='medium txt16 mrgB5 mrgT10 lineH23'>Consultez les offres locales pour dynamiser votre territoire</p>
                                            <p className='noMrgT mrgB10 txt16 thin'>
                                                boldee connecte les entreprises et les collectivités pour créer des synergies, stimuler l’innovation et renforcer l’économie locale.
                                            </p>
                                            <Link to="/" className="aReset bT mrgT20">
                                                <Button variant="outline" size="xs" color="gray" radius="xl">
                                                    <p className=' txt14'>Découvrir</p>
                                                </Button>
                                            </Link>
                                        </div>
                                        <div className='mrgB50'>
                                            <ThemeIcon size="xl" className='noMrgTB' color="#40c057">
                                                <IconWorldStar style={{ width: '70%', height: '70%' }} />
                                            </ThemeIcon>
                                            <p className='medium txt16 mrgB5 mrgT10 lineH23'>Connectez-vous et faites rayonner votre activité et votre impact durable</p>
                                            <p className='noMrgT mrgB10 txt16 thin'>Valorisez ce que vous faites, partagez vos ressources et laissez votre engagement social et environnemental parler pour vous. Chaque connexion devient une opportunité de renforcer votre image.</p>
                                            <Link to="/" className="aReset bT mrgT20">
                                                <Button variant="outline" size="xs" color="gray" radius="xl">
                                                    <p className='txt14'>En savoir plus</p>
                                                </Button>
                                            </Link>                   
                                        </div>                                        
                                    </div>

                                    <div className='mrgT10 width90pCenter vertical jCenter'>
                                        <div className='mrgB20'> <MeetingPic /></div>

                                        <div className='medium txt25 w40'>boldee est <span className='highlightLime'>actuellement testé</span> avec des entreprises et des collectivités engagées lors d’ateliers de co-construction</div>
                                    </div>
                                    <div className='vertical mrgT30 mrgB30'>
                                        <div className='w40'>
                                            <Blockquote color="teal" cite="– Manager opérationnel - Participant à un atelier de test" mt="xl">
                                                <span className='txt16'>
                                                    Nous avons facilement accès à des ressources techniques et matérielles à proximité, à des prix raisonnables. De plus, cela nous permet de tisser des liens avec nos voisins !
                                                </span>        
                                            </Blockquote>
                                        </div>

                                        <div className='w40'>
                                            <Blockquote color="teal" cite="– Dirigeant - Participant à un atelier de test" mt="xl">
                                                <span className='txt16'>
                                                    Aujourd’hui, les entreprises ont besoin de solutions pragmatiques. Boldee permet de mieux utiliser l’existant, de réduire et d’amortir rapidement les coûts d’achat, tout en soutenant l’économie locale et en structurant les démarches qualité et environnementales.
                                                </span>        
                                            </Blockquote>
                                        </div>

                                        <div className='w40'>
                                            <Blockquote color="teal" cite="– Expert RSE & CSRD - Participant à un atelier de test" mt="xl">
                                                <span className='txt16'>   
                                                    boldee pose des bases solides pour un futur label de référence en matière de valorisation des ressources, d’impact environnemental et de développement économique.
                                                </span>        
                                            </Blockquote>
                                        </div>
                                    </div>

                                    <div className='width90pCenter'>
                                        <span className='txt18 medium'>Rejoignez les entreprises et les collectivités qui testent boldee</span>
                                        <div className='mrgT10'>
                                            <form onSubmit={form2.onSubmit(handleFormSubmit)}>
                                                <div className="txtLeft">
                                                    <div className='mrgB5'>
                                                    <TextInput
                                                        size="sm"
                                                        placeholder="votre@email.com"
                                                        {...form2.getInputProps('email')}
                                                    /> 
                                                    </div>
                        
                                                    <div>
                                                        <Button 
                                                            type="submit"
                                                            color="green"
                                                            size="sm"
                                                            >
                                                            <span className='txt14 bT'>Rejoindre</span>
                                                        </Button>
                                                        {open  
                                                            ?   <Modal 
                                                                    centered
                                                                    size="auto"
                                                                    opened={opened}
                                                                    onClose={close}
                                                                    withCloseButton={false}>
                                                                    <p className=" txt15 txtCenter noMrgTB">
                                                                        Votre demande a été envoyée
                                                                    </p>
                                                                </Modal> 
                                                            :   ""
                                                        }
                                                    </div>
                                                </div>
                                            </form>                          
                                        </div>
                                    </div>   

                                    <div className='mrgT50'>                                        
                                        <div className='vertical iCenter width90pCenter'>
                                            <div className='txtCenter mrgB20'><RSEPic /></div>
                                            <div className='vertical padStoryTelling txt16'>
                                                <div className='mrgB10 txtJustify'>
                                                    Guidée par la <span className='highlightLime bold'>réutilisation</span> et <span className='highlightLime bold'>l’innovation des échanges professionnels</span>, boldee est née d’un constat :
                                                </div>
                                                <div className='mrgB10 txtJustify'>
                                                    Les entreprises disposent de ressources dormantes ou sous-utilisées qui pourraient créer de la valeur si elles étaient connectées — que ce soit pour générer des revenus ou faire des économies.
                                                </div>
                                                <div className='mrgB20 txtJustify'>
                                                    Dans un contexte économique difficile, où la pression sur les coûts est forte et où les entreprises cherchent à optimiser chaque ressource, les impacts sociaux et environnementaux deviennent également incontournables : gaspillage, surconsommation et opportunités humaines inexploitées pèsent lourdement sur notre société et notre planète. 🌍
                                                </div>
                                                <div className='mrgB10 medium'>
                                                    boldee accompagne les entreprises pour transformer ces défis en opportunités : 
                                                </div>
                                                <div className='medium mrgL10'>- en valorisant les ressources existantes,</div>
                                                <div className='medium mrgL10'>- en favorisant les échanges locaux et responsables,</div>
                                                <div className='medium mrgL10'>- et en soutenant un modèle économique à la fois durable et humain.</div>
                                                <Link to="/" className="aReset bT mrgT30">
                                                    <Button variant="outline" size="xs" color="gray" radius="xl">
                                                        <p className='txt14'>En savoir plus</p>
                                                    </Button>
                                                </Link> 
                                            </div>
                                             
                                            
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <CookieConsent 
                                        debug={true}
                                        location="bottom"
                                        buttonText="Accepter"
                                        cookieName="complianceRGPD_ga"
                                        style={{ 
                                            background: "#303030",
                                            color: "#FFFFFF",
                                            fontFamily: "'Segoe UI', sans-serif",
                                            paddingLeft: "10px",
                                            maxWidth: "100vw",
                                            boxSizing: "border-box",
                                        }}
                                        buttonStyle={{ fontWeight: "bold", color: "#000000", background: "#FFFFFF", fontSize: "16px", borderRadius: "2px", marginRight: "40px" }}
                                        enableDeclineButton
                                        declineButtonText="Refuser"
                                        declineButtonStyle={{ color: "#FFFFFF", background: "#303030", fontSize: "16px", borderRadius: "2px", borderWidth:"10px", borderColor:"#FFFFFF", marginRight: "5px" }}
                                        expires={150}    
                                        >                                    
                                        <p className='txt16'>
                                            Nous utilisons des cookies pour optimiser votre expérience utilisateur et pour améliorer nos contenus.
                                        </p>
                                    </CookieConsent>
                                    <div className='horizontal spaceBtw bLiteGrey txtCenter'>
                                            <div className='width90pCenter mrgB100 w60'>
                                                <div>
                                                    <p className='mrgT150 txt50 medium lineH65 mrgB20'>
                                                        boldee, un espace d’offres interentreprises pour donner une seconde vie à vos ressources
                                                    </p>
                                                </div>
                                                <div>
                                                    <p className='mrgB30 txt25 mrgT10 vertical'>
                                                        <p className='noMrgT mrgB10 thin'>Entreprises et Collectivités : créer de la valeur avec l’existant, réduire les coûts, agir durablement.</p>
                                                    </p>
                                                </div>
                                                <div>
                                                     <form onSubmit={form1.onSubmit(handleFormSubmit)}>
                                                        <div className="horizontal jCenter txtLeft">
                                                            <div>
                                                            <TextInput
                                                                size="lg"
                                                                placeholder="votre@email.com"
                                                                style={{
                                                                width: '450px',
                                                                }}
                                                                {...form1.getInputProps('email')}
                                                            /> 
                                                            </div>
                                
                                                            <div>
                                                                <Button 
                                                                    type="submit"
                                                                    color="green"
                                                                    size="lg"
                                                                    >
                                                                    <span className='txt16 bT'>Recevez notre plaquette</span>
                                                                </Button>
                                                                {open  
                                                                    ?   <Modal 
                                                                            centered
                                                                            size="auto"
                                                                            opened={opened}
                                                                            onClose={close}
                                                                            withCloseButton={false}>
                                                                            <p className=" txt15 txtCenter noMrgTB">
                                                                                Notre plaquette vous a été envoyé
                                                                            </p>
                                                                        </Modal> 
                                                                    :   ""
                                                                }
                                                            </div>
                                                        </div>
                                                    </form>                          
                                                </div>
                                            </div>

                                    </div>
                                    
                                    <div className="width90pCenter horizontal iStart mrgT100 mrgB50 spaceBtw">
                                        
                                        <div className='w30 mrgB50'>
                                            <ThemeIcon size="xl" className='noMrgTB' color="#40c057">
                                                <IconExchange style={{ width: '70%', height: '70%' }} />
                                            </ThemeIcon>
                                            <p className='medium txt20 mrgB5 mrgT10 lineH23'>Ne laissez plus vos ressources matérielles et immatérielles dormir</p>
                                            <p className='noMrgT txt20 txt18 thin'>
                                                Vendez ou louez vos locaux, équipements, outils ou savoir-faire pour générer des revenus, et économisez grâce aux offres disponibles sur la plateforme boldee.
                                            </p>
                                            <Link to="/" className="aReset bT mrgT20">
                                                <Button variant="outline" size="sm" color="gray" radius="xl">
                                                    <p className='txt16'>Découvrir</p>
                                                </Button>
                                            </Link>
                                        </div>
                                        <div className='w30 mrgB50'>
                                            <ThemeIcon size="xl" className='noMrgTB' color="#40c057">
                                                <IconFlagPin style={{ width: '70%', height: '70%' }} />
                                            </ThemeIcon>
                                            <p className='medium txt20 mrgB5 mrgT10 lineH23'>Consultez les offres locales pour dynamiser votre territoire</p>
                                            <p className='noMrgT mrgB10 txt20 thin'>
                                                boldee connecte les entreprises et les collectivités pour créer des synergies, stimuler l’innovation et renforcer l’économie locale.
                                            </p>
                                            <Link to="/" className="aReset bT mrgT20">
                                                <Button variant="outline" size="sm" color="gray" radius="xl">
                                                    <p className=' txt16'>Découvrir</p>
                                                </Button>
                                            </Link>
                                        </div>
                                        <div className='w30 mrgB50'>
                                            <ThemeIcon size="xl" className='noMrgTB' color="#40c057">
                                                <IconWorldStar style={{ width: '70%', height: '70%' }} />
                                            </ThemeIcon>
                                            <p className='medium txt20 mrgB5 mrgT10 lineH23'>Connectez-vous et faites rayonner votre activité et votre impact durable</p>
                                            <p className='noMrgT mrgB10 txt20 thin'>Valorisez ce que vous faites, partagez vos ressources et laissez votre engagement social et environnemental parler pour vous. Chaque connexion devient une opportunité de renforcer votre image.</p>
                                            <Link to="/" className="aReset bT mrgT20">
                                                <Button variant="outline" size="sm" color="gray" radius="xl">
                                                    <p className='txt16'>En savoir plus</p>
                                                </Button>
                                            </Link>                   
                                        </div>                                        
                                    </div>

                                    <div className='mrgT200 width90pCenter horizontal iCenter'>
                                        <div className='medium txt35 w40'>boldee est <span className='highlightLime'>actuellement testé</span> avec des entreprises et des collectivités engagées lors d’ateliers de co-construction</div>
                                        <div className='noMrgTB'> <MeetingPic /></div>
                                    </div>
                                    <div className='width90pCenter horizontal spaceBtw mrgT100 mrgB100 roboto'>
                                        <div className='w40'>
                                        <Blockquote color="teal" cite="– Manager opérationnel - Participant à un atelier de test" mt="xl">
                                        <span className ="txt20">
                                            Nous avons facilement accès à des ressources techniques et matérielles à proximité, à des prix raisonnables. De plus, cela nous permet de tisser des liens avec nos voisins !
                                        </span>
                                        </Blockquote>
                                        </div>

                                        <div className='w40'>
                                        <Blockquote color="teal" cite="– Dirigeant - Participant à un atelier de test" mt="xl">
                                        <span className ="txt20">
                                            Aujourd’hui, les entreprises ont besoin de solutions pragmatiques. Boldee permet de mieux utiliser l’existant, de réduire et d’amortir rapidement les coûts d’achat, tout en soutenant l’économie locale et en structurant les démarches qualité et environnementales.
                                        </span>
                                        </Blockquote>
                                        </div>

                                        <div className='w40'>
                                        <Blockquote color="teal" cite="– Expert RSE & CSRD - Participant à un atelier de test" mt="xl">
                                        <span className ="txt20"> 
                                            boldee pose des bases solides pour un futur label de référence en matière de valorisation des ressources, d’impact environnemental et de développement économique.
                                        </span>
                                        </Blockquote>
                                        </div>
                                    </div>

                                    <div className='txtCenter'>
                                        <h1>Rejoignez les entreprises et les collectivités qui testent boldee</h1>
                                        <div>
                                            <form onSubmit={form2.onSubmit(handleFormSubmit)}>
                                                <div className="horizontal jCenter txtLeft">
                                                    <div>
                                                    <TextInput
                                                        size="lg"
                                                        placeholder="votre@email.com"
                                                        style={{
                                                        width: '450px',
                                                        }}
                                                        {...form2.getInputProps('email')}
                                                    /> 
                                                    </div>
                        
                                                    <div>
                                                        <Button 
                                                            type="submit"
                                                            color="green"
                                                            size="lg"
                                                            >
                                                            <span className='txt16 bT'>Rejoindre</span>
                                                        </Button>
                                                        {open  
                                                            ?   <Modal 
                                                                    centered
                                                                    size="auto"
                                                                    opened={opened}
                                                                    onClose={close}
                                                                    withCloseButton={false}>
                                                                    <p className=" txt15 txtCenter noMrgTB">
                                                                        Notre plaquette vous a été envoyé
                                                                    </p>
                                                                </Modal> 
                                                            :   ""
                                                        }
                                                    </div>
                                                </div>
                                            </form>                          
                                        </div>
                                    </div>   

                                    <div className='mrgT100'>                                        
                                        <div className='horizontal iCenter width90pCenter'>
                                            <RSEPic />
                                            <div className='width70pCenter vertical padStoryTelling txt18'>
                                                <div className='mrgB10 txtJustify txt20'>
                                                    Guidée par la <span className='highlightLime bold'>réutilisation</span> et <span className='highlightLime bold'>l’innovation des échanges professionnels</span>, boldee est née d’un constat :
                                                </div>
                                                <div className='mrgB10 txtJustify txt20'>
                                                    Les entreprises disposent de ressources dormantes ou sous-utilisées qui pourraient créer de la valeur si elles étaient connectées — que ce soit pour générer des revenus ou faire des économies.
                                                </div>
                                                <div className='mrgB20 txtJustify txt20'>
                                                    Dans un contexte économique difficile, où la pression sur les coûts est forte et où les entreprises cherchent à optimiser chaque ressource, les impacts sociaux et environnementaux deviennent également incontournables : gaspillage, surconsommation et opportunités humaines inexploitées pèsent lourdement sur notre société et notre planète. 🌍
                                                </div>
                                                <div className='mrgB10 medium txtJustify txt20'>
                                                    boldee accompagne les entreprises pour transformer ces défis en opportunités : 
                                                </div>
                                                <div className='medium mrgL30 txt20'>- en valorisant les ressources existantes,</div>
                                                <div className='medium mrgL30 txt20'>- en favorisant les échanges locaux et responsables,</div>
                                                <div className='medium mrgL30 txt20'>- et en soutenant un modèle économique à la fois durable et humain.</div>
                                                <Link to="/" className="aReset bT mrgT20">
                                                    <Button variant="outline" size="md" color="gray" radius="xl">
                                                        <p className='txt16'>En savoir plus</p>
                                                    </Button>
                                                </Link> 
                                            </div>
                                             
                                            
                                        </div>
                                    </div>
                                </>
                            )}

                        </div>
                    <Footer/>

                </>
            )}
        </>
    );
}



export default Home;
